import * as yup from 'yup'

export const schema = yup.object().shape({
  endpoint: yup.string().required(),
})

export default schema
